<template>
  <van-checkbox
      ref="agreement"
      v-bind="$attrs"
      v-on="$listeners"
      icon-size="20px">
    我已充分知情，并同意上传身份证和人脸等照片用于申请和使用电子出入证
    <span style="color: #4BB1F8" @click.stop="showAgreement">
          《电子出入证申请须知》
        </span>
  </van-checkbox>
</template>

<script>
import {Dialog, Checkbox} from "vant";

export default {
  name: "DpConstructionAgreement",
  components: {
    'van-checkbox': Checkbox
  },
  data() {
    return {
      agreementContent:
          "1．电子出入证申请需提供您本人身份证照片和人脸照片，收集的相片仅供生成电子出入证，以便核对您的身份，方便您使用电子出入证快速通" +
          "行和配合物业安全管理需要。【照片存储于电子出入证系统中并严格保密，在收到您关于删除您所登记的个人信息的通知后或者收到您所属公司关" +
          "于删除您所登记的个人信息的通知后，我们将在15天内删除您所登记的个人信息(法律法规或地方规章政策另有规定的除外)】\n" +
          "2．如物业进行扫码验真通行或安全巡场管理，请出示电子出入证，扫码验真。",
    }
  },
  methods: {
    showAgreement() {
      //申请电子出入证须知
      Dialog.alert({
        messageAlign: 'left',
        title: '申请电子出入证须知',
        message: this.agreementContent
      }).then(() => {
        // on close
      });
    },
  }
}
</script>

<style scoped>

</style>